import { defineEvent } from "@gr-exports/async/nexus";
import { onLoad } from "@gr-exports/async/dom";
import { trackLegacySelectors } from "./async/tracking";
import { getScript, getScriptSafe } from "./async/getScript";
import { initializeMountingHooks, onMount, onUnmount } from "./async/hooks";

/*                                                 */
/*                                   */
otto.dom.assignNamespace(
  {
    onLoad: defineEvent(),
    onReady: defineEvent(),
    getScript,
    getScriptSafe,
    onMount,
    onUnmount,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);

/*                    */
initializeMountingHooks();
onLoad.sub(trackLegacySelectors);
